// FET-2766 / FET-2641: guarantee badge + countdown visibility helpers for checkout markup.

export const GUARANTEE_IMAGES = Object.freeze({
	lifetime: 'https://assets.sculptnation.com/cms/sales-pages/be-v2/moneyback-badge.webp',
	default: 'https://d1rolxk7wi0t82.cloudfront.net/cms/sculptnation/img/checkout/v3/30-day-money-back-guarantee-opt.webp',
	defaultTrust: 'https://le.vshred.com/cdn-cgi/image/format=webp,quality=80/https://assets.sculptnation.com/cms/sculptnation/img/checkout/v3/checkout-vince-img.png',
	60: 'https://d1rolxk7wi0t82.cloudfront.net/cms/sculptnation/img/checkout/v3/60-day-money-back-guarantee-opt.webp',
});

/** Only supported digital-product overrides are accepted (30 or 60 days). */
export const getDigitalGuaranteeDays = (productData) => {
	const configuredDays = Number(productData?.guarantee_days);
	return Number.isInteger(configuredDays) && configuredDays === 60 ? 60 : 30;
};

/** Per-offer countdown_enabled takes precedence over skin settings; defaults to enabled. */
export const isCountdownTimerEnabled = (productData, skin) => {
	if (typeof productData?.countdown_enabled === 'boolean') {
		return productData.countdown_enabled;
	}
	if (typeof skin?.settings?.countdown_timer?.enabled === 'boolean') {
		return skin.settings.countdown_timer.enabled;
	}
	return true;
};

export const resolveGuaranteeBanner = ({ cartHasPhysicalProduct, guaranteeDays }) => {
	if (cartHasPhysicalProduct) {
		return 'lifetime';
	}
	return guaranteeDays === 60 ? '60-day' : 'default';
};

export const resolveGuaranteeBadgeImageUrl = (guaranteeBanner) => {
	if (guaranteeBanner === 'lifetime') {
		return GUARANTEE_IMAGES.lifetime;
	}
	return guaranteeBanner === '60-day' ? GUARANTEE_IMAGES[60] : GUARANTEE_IMAGES.default;
};

export const resolveGuaranteeTrustImageUrl = (guaranteeBanner) => {
	if (guaranteeBanner === 'lifetime') {
		return GUARANTEE_IMAGES.lifetime;
	}
	return guaranteeBanner === '60-day' ? GUARANTEE_IMAGES[60] : GUARANTEE_IMAGES.defaultTrust;
};
